/**
 * Michigan statutory constants. Single company, single state, so these are
 * constants in code rather than configuration (invariant 7).
 *
 * The timing logic and notice templates here are attorney-reviewed. Flag a
 * needed change; do not silently adjust one.
 */
import { Decimal } from 'decimal.js';
/**
 * MCL 554.602 — a security deposit may not exceed 1.5 months' rent.
 * Validated at lease creation, not at move-in, because the signed lease is the
 * document that has to be compliant.
 */
export const DEPOSIT_CAP_MULTIPLE = new Decimal('1.5');
/**
 * MCL 554.603 — within 14 days of receiving a deposit the landlord must give
 * written notice naming the financial institution and its address.
 */
export const DEPOSIT_NOTICE_DAYS = 14;
/**
 * MCL 554.608 — two blank copies of an itemized move-in checklist at move-in;
 * the tenant returns one within 7 days.
 */
export const MOVE_IN_CHECKLIST_COPIES = 2;
export const MOVE_IN_CHECKLIST_RETURN_DAYS = 7;
/**
 * MCL 554.609 — itemized damages plus the deposit balance must reach the tenant
 * within 30 days of termination of occupancy. Missing it forfeits the right to
 * withhold anything AND exposes the company to double damages under MCL
 * 554.613. This is the loudest alert in the application.
 */
export const MOVE_OUT_NOTICE_DAYS = 30;
/**
 * Escalation ladder for the 30-day clock, in days from the move-out date.
 * Day 25 is the last point at which first-class mail still reliably lands
 * inside the window.
 */
export const MOVE_OUT_ESCALATION_DAYS = [14, 21, 25];
/** MCL 554.609 — the tenant has 7 days to respond disputing the damages. */
export const TENANT_DISPUTE_RESPONSE_DAYS = 7;
/**
 * MCL 554.603(2) — the forwarding-address warning must be in type at least
 * 12 point and at least four sizes larger than the body of the lease. This is a
 * hard constraint on PDF generation, not a style preference: if the lease body
 * renders at 11pt the warning has to be at least 15pt, and 12pt is the floor
 * regardless.
 */
export const FORWARDING_NOTICE_MIN_POINT_SIZE = 12;
export const FORWARDING_NOTICE_POINT_SIZES_LARGER_THAN_BODY = 4;
/** Resolve the required warning type size for a given lease body size. */
export function forwardingNoticePointSize(leaseBodyPointSize) {
    return Math.max(FORWARDING_NOTICE_MIN_POINT_SIZE, leaseBodyPointSize + FORWARDING_NOTICE_POINT_SIZES_LARGER_THAN_BODY);
}
/** MCL 554.602 deposit cap for a given monthly rent. */
export function maxSecurityDeposit(monthlyRent) {
    return new Decimal(monthlyRent).times(DEPOSIT_CAP_MULTIPLE).toDecimalPlaces(2);
}
export function isDepositWithinCap(deposit, monthlyRent) {
    return new Decimal(deposit).lessThanOrEqualTo(maxSecurityDeposit(monthlyRent));
}
//# sourceMappingURL=michigan.js.map